import type { Pinia } from 'pinia'
import { useWorkspace } from '~/stores/workspace'

export default defineNuxtRouteMiddleware(async () => {
  const { $groundcover, $pinia } = useNuxtApp()
  const workspace = useWorkspace($pinia as Pinia)

  if (!import.meta.client) {
    return
  }

  if (!workspace.isRialticAdmin) {
    $groundcover?.sendCustomEvent({
      event: 'Access admin - DENIED',
      attributes: {},
    })

    return abortNavigation()
  }
})
